import React from "react"
import PropTypes from 'prop-types';
import * as S from "./BodyOptions.Style";
import ActionChat from "../../common/ActionChat";
import Link from "../../common/Link";

const BodyOptions = ({ titleOption, DescriptionOption, chatId }) => {
    const ChatModalButton = (props) => <ActionChat {...props} as={Link} style={{textDecoration: "none"}} />;
    return (
        <>
            <S.ContentOptionForChat>
                <S.TitleOptionForChat>
                    {titleOption}
                </S.TitleOptionForChat>
                <S.DescriptionOptionForChat>
                    {DescriptionOption}
                </S.DescriptionOptionForChat>
                <S.ContentButton>
                    <S.ButtonOptionForChat as={ChatModalButton} chatId={chatId} >
                        <S.TextButtonOptionForChat>
                            Iniciar
                        </S.TextButtonOptionForChat>
                    </S.ButtonOptionForChat>
                </S.ContentButton>
            </S.ContentOptionForChat>
            <S.OptionDivider />
        </>
    )
}

BodyOptions.propTypes = {
    titleOption: PropTypes.string.isRequired,
    DescriptionOption: PropTypes.string.isRequired,
    chatId: PropTypes.string.isRequired,
}

export default BodyOptions